<!-- eslint-disable vue/singleline-html-element-content-newline -->
<template>
  <div class="flex-container">
    <div class="flex-row">
      <div class="left-header" />
      <div class="main-header">Head</div>
      <div class="main-header">Body</div>
    </div>
    <div class="flex-row">
      <div class="cell-border left-header">
        <span class="text-green">AC:</span>
        <span class="text-white">{{
          Math.round(state.build.CharStats.ArmorClass.value)
        }}</span>
      </div>
      <div class="top-header">DT</div>
      <div class="top-header">DR</div>
      <div class="top-header">DT</div>
      <div class="top-header">DR</div>
    </div>
    <div class="flex-row">
      <div class="left-header">Normal</div>
      <div class="value-cell">
        {{ getResistanceData.advanced.head.NoDT }}
      </div>
      <div class="value-cell">
        {{ getResistanceData.advanced.head.NoDR }}
        <span class="percent-span">%</span>
      </div>
      <div class="value-cell">
        {{ getResistanceData.advanced.body.NoDT }}
      </div>
      <div class="value-cell">
        {{ getResistanceData.advanced.body.NoDR }}
        <span class="percent-span">%</span>
      </div>
    </div>
    <div class="flex-row">
      <div class="dark-bg left-header">Laser</div>
      <div class="dark-bg value-cell">
        {{ getResistanceData.advanced.head.LaDT }}
      </div>
      <div class="dark-bg value-cell">
        {{ getResistanceData.advanced.head.LaDR }}
        <span class="percent-span">%</span>
      </div>
      <div class="dark-bg value-cell">
        {{ getResistanceData.advanced.body.LaDT }}
      </div>
      <div class="dark-bg value-cell">
        {{ getResistanceData.advanced.body.LaDR }}
        <span class="percent-span">%</span>
      </div>
    </div>
    <div class="flex-row">
      <div class="left-header">Fire</div>
      <div class="value-cell">
        {{ getResistanceData.advanced.head.FiDT }}
      </div>
      <div class="value-cell">
        {{ getResistanceData.advanced.head.FiDR }}
        <span class="percent-span">%</span>
      </div>
      <div class="value-cell">
        {{ getResistanceData.advanced.body.FiDT }}
      </div>
      <div class="value-cell">
        {{ getResistanceData.advanced.body.FiDR }}
        <span class="percent-span">%</span>
      </div>
    </div>
    <div class="flex-row">
      <div class="dark-bg left-header">Plasma</div>
      <div class="dark-bg value-cell">
        {{ getResistanceData.advanced.head.PlDT }}
      </div>
      <div class="dark-bg value-cell">
        {{ getResistanceData.advanced.head.PlDR }}
        <span class="percent-span">%</span>
      </div>
      <div class="dark-bg value-cell">
        {{ getResistanceData.advanced.body.PlDT }}
      </div>
      <div class="dark-bg value-cell">
        {{ getResistanceData.advanced.body.PlDR }}
        <span class="percent-span">%</span>
      </div>
    </div>
    <div class="flex-row">
      <div class="left-header">Explode</div>
      <div class="value-cell">
        {{ getResistanceData.advanced.head.ExDT }}
      </div>
      <div class="value-cell">
        {{ getResistanceData.advanced.head.ExDR }}
        <span class="percent-span">%</span>
      </div>
      <div class="value-cell">
        {{ getResistanceData.advanced.body.ExDT }}
      </div>
      <div class="value-cell">
        {{ getResistanceData.advanced.body.ExDR }}
        <span class="percent-span">%</span>
      </div>
    </div>
    <div class="flex-row">
      <div class="dark-bg left-header">Electrical</div>
      <div class="dark-bg value-cell">
        {{ getResistanceData.advanced.head.ElDT }}
      </div>
      <div class="dark-bg value-cell">
        {{ getResistanceData.advanced.head.ElDR }}
        <span class="percent-span">%</span>
      </div>
      <div class="dark-bg value-cell">
        {{ getResistanceData.advanced.body.ElDT }}
      </div>
      <div class="dark-bg value-cell">
        {{ getResistanceData.advanced.body.ElDR }}
        <span class="percent-span">%</span>
      </div>
    </div>
    <div class="flex-row">
      <div class="left-header">Radiation</div>
      <div class="value-cell">
        {{ getResistanceData.radiation }}
        <span class="percent-span">%</span>
      </div>
    </div>
    <div class="flex-row">
      <div class="dark-bg left-header">Poison</div>
      <div class="dark-bg value-cell">
        {{ getResistanceData.poison }}
        <span class="percent-span">%</span>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed, defineComponent } from "vue";
export default defineComponent({
  name: "ResistanceTable",
  components: {},
  setup() {
    const store = useStore();
    const getResistanceData = computed(() => {
      return {
        advanced: store.state.build.AdvancedDR,
        radiation: store.state.build.CharStats.RadResistance.value,
        poison: store.state.build.CharStats.PoisonResistance.value,
      };
    });
    return {
      state: store.state,
      getResistanceData,
    };
  },
});
</script>
<!-- REVISED -->
<style scoped>
.percent-span {
  margin-left: 3px;
}
.dark-bg {
  background: var(--tr-bg-2);
  border: 1px solid var(--sub-panel-bg);
  border-radius: 3px;
}
.cell-border {
  border: var(--td-border);
  border-radius: 3px;
  color: white;
}
.flex-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2px;
  width: 95%;
  border: var(--td-border);
  border-radius: 3px;
  margin: auto;
  box-sizing: border-box;
  background-color: var(--sub-panel-bg);
  padding: 2px;
  font-size: 14px;
}
.flex-container:hover {
  border: 1px solid rgba(145, 255, 55, 0.728);
}
.flex-row {
  width: 100%;
  display: flex;
  gap: 2px;
  justify-content: space-between;
  min-height: 20px;
  box-sizing: border-box;
}
.left-header {
  min-width: 80px;
  /* border: 1px solid var(--sub-panel-bg); */
  box-sizing: border-box;
  border-radius: 3px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.main-header {
  width: 100%;
  font-size: 16px;
}
.top-header {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.value-cell {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  /* border: 1px solid var(--sub-panel-bg); */
  border: var(--td-border);
  border-radius: 3px;
  font-size: 16px;
}
</style>
